import { AddressTypeEnum } from "src/app/shared/Models/enums/AddressTypeEnum";
import { BuildingTypeEnum } from "src/app/shared/Models/enums/BuildingTypeEnum";
import { SaveOutsideSurveyUnitInfoDto } from "src/app/shared/Models/write/SaveOutsideSurveyUnitInfoDto";
import { buildingTypeMessages } from "./building-type-validation.messages";

export const buildingTypeValidationRules = {
  [-1]: () => buildingTypeMessages.buildingCharacteristicEmpty,
  [BuildingTypeEnum.InUse]: (dto: any, totalUnits: number) => {
    if (totalUnits == 0) return buildingTypeMessages.inUseAtleastOneUnit;
    if (dto.changeAddressTypes)
      if (totalUnits <= dto.changeAddressTypes?.length) return true;
      else
        return (
          dto.changeAddressTypes?.some(
            (r) => +r.addressType == AddressTypeEnum.InUseMultipleUnits
          ) || buildingTypeMessages.inUseAtleastOneMultipleUnits
        );
    else if (dto.addresses)
      if (totalUnits <= dto.addresses?.length) return true;
      else
        return (
          dto.addresses?.some(
            (r) => +r.addressType == AddressTypeEnum.InUseMultipleUnits
          ) || buildingTypeMessages.inUseAtleastOneMultipleUnits
        );
  },
  [BuildingTypeEnum.NoAccess]: (dto: any, totalUnits: number) => {
    if (totalUnits < 2) return buildingTypeMessages.noAccesAtleastTwoUnits;
    if (dto.changeAddressTypes)
      if (totalUnits <= dto.changeAddressTypes?.length) return true;
      else
        return (
          dto.changeAddressTypes?.some(
            (r) => +r.addressType == AddressTypeEnum.InUseMultipleUnits
          ) || buildingTypeMessages.inUseAtleastOneMultipleUnits
        );
    else if (dto.addresses)
      if (totalUnits <= dto.addresses?.length) return true;
      else
        return (
          dto.addresses?.some(
            (r) => +r.addressType == AddressTypeEnum.InUseMultipleUnits
          ) || buildingTypeMessages.inUseAtleastOneMultipleUnits
        );
  },
  [1]: () => buildingTypeMessages.inUseMultipleBuildingType,
  [BuildingTypeEnum.EmptyParcel]: (
    dto: SaveOutsideSurveyUnitInfoDto,
    totalUnits: number
  ) => totalUnits > 0 || buildingTypeMessages.emptyParcelAtleastOneUnit,
  [BuildingTypeEnum.StudentHome]: (dto: any, totalUnits: number) => {
    switch (true) {
      case totalUnits < 1:
        return buildingTypeMessages.studentHomeAtleastOneUnit;
      case dto.numberOfBu < 1:
        return buildingTypeMessages.studentHomeAtleastOneBU;
      case dto.studentHomeCount < 1:
        return buildingTypeMessages.studentHomeAtleastOneStudentHome;
      case dto.studentHomeCount !=
        (dto.changeAddressTypes
          ? dto.changeAddressTypes.reduce(
              (sum, address) => sum + address.studentHomeCount,
              0
            )
          : dto.addresses.reduce(
              (sum, address) => sum + address.studentHomeCount,
              0
            )):
        return buildingTypeMessages.studentHomeCountNotEqual;
      default:
        return true;
    }
  },
  [BuildingTypeEnum.NotInUse]: (
    dto: SaveOutsideSurveyUnitInfoDto,
    totalUnits: number
  ) => totalUnits == 0 || buildingTypeMessages.notInUse0Units, //This is explained in the ticket, however will always fail when a building is MDU + NotInUse
  [BuildingTypeEnum.InUseWithoutBuildingUnit]: (
    dto: any,
    totalUnits: number
  ) => {
    // no validation on street survey but more than 1 to validate after site survey
    if (totalUnits > 0) return buildingTypeMessages.inUseWithoutBuildingUnit;

    if (dto.changeAddressTypes)
      return (
        dto.changeAddressTypes?.some(
          (r) => +r.addressType == AddressTypeEnum.InUseZeroUnits
        ) || buildingTypeMessages.inUseZeroUnitsAddressAtLeastOne
      );
    else if (dto.addresses)
      return (
        dto.addresses?.some(
          (r) => +r.addressType == AddressTypeEnum.InUseZeroUnits
        ) || buildingTypeMessages.inUseZeroUnitsAddressAtLeastOne
      );

    return true;
  },
};
